import { useT } from 'i18n';
import { avance, money, num, diasHasta, textoDias, nombrePais } from './utils';

const TarjetaProyecto = ({ p, secundario, onAbrir }) => {
  const { t } = useT();
  const pct = avance(p);
  const dias = diasHasta(p.end_date);
  const disponible = Math.max(0, num(p.amount) - num(p.amount_investment));
  const nombre = p.name || p.nrocontrato || t('mercado.proyecto');

  return (
    <article className="p7m-card">
      <header className="p7m-card-top">
        <span className="p7m-chip">{p.category || t('mercado.proyecto')}</span>
        {p.country_iso && <span className="p7m-pais">{nombrePais(p.country_iso)}</span>}
      </header>

      <h3 className="p7m-card-name" title={nombre}>{nombre}</h3>
      <p className="p7m-card-sub">{p.oferente?.name || p.issuer || p.tipo || ''}</p>

      {secundario ? (
        <div className="p7m-precio">
          <span>{t('mercado.precioVenta')}</span>
          <strong>{money(p.precioventa)} <small>USDT</small></strong>
          {p.precio_original && <em>{t('mercado.valorOriginal', { monto: money(p.precio_original) })}</em>}
        </div>
      ) : (
        <div className="p7m-avance">
          <div className="p7m-avance-top">
            <strong>{pct}%</strong>
            <span>{t('mercado.financiado')}</span>
            <span className="p7m-avance-disp">{t('mercado.disponibles', { monto: money(disponible, 0) })}</span>
          </div>
          <div className="p7m-barra" role="progressbar" aria-valuenow={pct} aria-valuemin="0" aria-valuemax="100">
            <i style={{ width: `${pct}%` }} />
          </div>
        </div>
      )}

      <dl className="p7m-datos">
        <div><dt>{t('mercado.tasa')}</dt><dd>{money(p.tax_referential_client)}%</dd></div>
        <div><dt>{t('mercado.venceEn')}</dt><dd>{textoDias(dias)}</dd></div>
        <div><dt>{t('mercado.riesgo')}</dt><dd>{p.risk || '—'}</dd></div>
        <div><dt>{t('mercado.garantia')}</dt><dd>{p.warranty || '—'}</dd></div>
      </dl>

      <button type="button" className="p7-btn-gold p7m-cta" onClick={() => onAbrir(p)}>
        {secundario ? t('mercado.verComprar') : t('mercado.verInvertir')}
      </button>
    </article>
  );
};

export default TarjetaProyecto;
